export const entitiesToArray = <T extends unknown>(entities: {
  [key: string]: T;
}): T[] => Object.keys(entities ?? {}).map((key) => entities[key]);
